import React, { useState } from 'react';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    TextField
} from '@mui/material';
const EventCreation = () => {
    const [eventName, setEventName] = useState('');
    const [eventDate, setEventDate] = useState('');
    const [eventLocation, setEventLocation] = useState('');

    const handleCreateEvent = (e) => {
        e.preventDefault();
        // Handle event creation logic here
        console.log('Event Created:', { eventName, eventDate, eventLocation });
    };

    return (
        <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} md={12}>
                <form>
                    {/* <div class="bg-white rounded-lg shadow p-8 max-w-md w-full border-t-4 border-red-700"> */}
                    <div className="bg-white rounded-lg p-8 space-y-4 flex flex-col shadow-2xl">
                        <div class="columns-2">
                            <div class="mb-4">
                                <label class="block text-sm font-semibold mb-1">Name of event: <span class="text-red-700">*</span></label>
                                <input type="text" class="w-full border rounded p-2" placeholder="Enter event name" />
                            </div>
                            <div class="mb-4">
                                <label class="block text-sm font-semibold mb-1">Location: <span class="text-red-700">*</span></label>
                                <select class="w-full border rounded p-2">
                                    <option>Choose a location</option>
                                </select>
                            </div>
                            <div class="mb-4">
                                <label class="block text-sm font-semibold mb-1">Date of event: <span class="text-red-700">*</span></label>
                                <div class="relative">
                                    <input type="date" class="w-full border rounded p-2" />
                                    <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                        <i class="far fa-calendar-alt text-red-700"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-4">
                                <label class="block text-sm font-semibold mb-1">Client:</label>
                                <select class="w-full border rounded p-2">
                                    <option>Select client</option>
                                </select>
                            </div>
                        </div>
                        <div class="mb-4">
                            <label class="block text-sm font-semibold mb-1">Notes:</label>
                            <textarea class="w-full border rounded p-2" rows="3" placeholder="Add any notes"></textarea>
                        </div>
                        <div class="columns-3">
                            <div class="mb-4"></div>
                            <div class="mb-4">
                                <button className="bg-red-900 text-white rounded-full px-16 py-2" onClick={handleCreateEvent}> Create Event</button>
                            </div>
                            <div class="mb-4"></div>
                        </div>
                    </div>
                </form>              
            </Grid>
        </Grid >
    );
};

export default EventCreation;